/**
 * @param parent {Element}
 * @param selector {string}
 * @return {Element}
 */
module.exports = function getChild(parent, selector) {
    return parent.querySelector(selector);
}